module.exports = __webpack_public_path__ + "img/cafe_pc_01.daac3bc4.png";